import { ExperienceInfo } from "./ExperienceInfo";
import experienceData from "./data/experienceData.json";


export function Experience () {
    return (
        <div className="flex flex-col justify-center scroll-mt-14 space-y-10 px-6 py-10 bg-white" id="experience">
            <h1 className="text-3xl font-bold w-11/12 lg:w-[954px] self-center font-dmsans text-red-600">Experience</h1>
            <div className="flex flex-wrap gap-4 w-11/12 lg:w-[954px] self-center font-dmsan text-sm text-gray-800">
                <span className="bg-gray-200 rounded-full w-fit px-3 py-2 hover:scale-[1.02]">
                    Full-Stack Development
                </span>
                <span className="bg-gray-200 rounded-full w-fit px-3 py-2 hover:scale-[1.02]">
                    User Interface Design
                </span>
                <span className="bg-gray-200 rounded-full w-fit px-3 py-2 hover:scale-[1.02]">
                    Database Management
                </span>
                <span className="bg-gray-200 rounded-full w-fit px-3 py-2 hover:scale-[1.02]">
                    Robotic Process Automation
                </span>
                <span className="bg-gray-200 rounded-full w-fit px-3 py-2 hover:scale-[1.02]">
                    API Integration
                </span>
            </div>
            <div className="w-11/12 lg:w-[954px] self-center">
                {experienceData.map(experience => 
                    <ExperienceInfo position={experience.position} company={experience.company} date={experience.date}/>
                )}
            </div>
        </div>   
    )
}